/* 右侧购物车的键盘与读屏器控制。保留主题既有的加购和购物车请求逻辑。 */
(function () {
  'use strict';

  var CART_DRAWER_SELECTOR = '#nt_cart_canvas';
  var CART_TRIGGER_SELECTOR = '.push_side[data-id="#nt_cart_canvas"]';
  var ADD_TO_CART_SELECTOR = '.js_addtc, .js_frm_cart, .js_add_group, .sticky_atc_js, form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] input[type="submit"]';
  var FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var controller = {
    lastOpener: null,
    pendingRemoval: null,
    pendingQuantityFocus: null,
    pendingQuantityFocusTimeout: null,
    openingFromController: false,
    quantityControlId: 0,

    init: function () {
      this.addStyles();
      this.decorate();
      this.decorateQuantityControls(document);
      this.decorateAddToCartControls(document);
      this.observeDrawer();

      document.addEventListener('click', this.onClick.bind(this), true);
      document.addEventListener('keydown', this.onKeydown.bind(this), true);
      document.addEventListener('theme:cart-change', this.onCartChange.bind(this));
      document.addEventListener('theme:cart-add', this.onCartAdd.bind(this));
    },

    addStyles: function () {
      if (document.getElementById('a11y-cart-drawer-styles')) return;
      var style = document.createElement('style');
      style.id = 'a11y-cart-drawer-styles';
      style.textContent = '.a11y-visually-hidden{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important}#nt_cart_canvas :focus-visible{outline:2px solid #005fcc!important;outline-offset:2px!important}';
      document.head.appendChild(style);
    },

    getDrawer: function () {
      return document.querySelector(CART_DRAWER_SELECTOR);
    },

    isOpen: function () {
      var drawer = this.getDrawer();
      return !!(drawer && drawer.classList.contains('act_opened'));
    },

    isVisible: function (element) {
      return !!(element && element.isConnected && element.getClientRects().length);
    },

    decorate: function () {
      var drawer = this.getDrawer();
      if (!drawer) return;

      drawer.setAttribute('aria-hidden', this.isOpen() ? 'false' : 'true');
      this.decorateQuantityControls(drawer);
      this.decorateAddToCartControls(drawer);
    },

    decorateQuantityControls: function (scope) {
      scope.querySelectorAll('.quantity input[type="number"]').forEach(function (input) {
        if (!input.id) {
          controller.quantityControlId += 1;
          input.id = 'a11y-quantity-' + controller.quantityControlId;
        }

        if (!input.getAttribute('aria-label')) {
          var item = input.closest('.js_cart_item');
          var title = item && item.querySelector('.mini_cart_title');
          var productScope = input.closest('form, .product-info, .product__info, .product-item, .pr_summary') || document;
          var productTitle = title || productScope.querySelector('[data-product-title], .product_title, .product-title, .entry-title, h1');
          input.setAttribute('aria-label', productTitle ? 'Quantity for ' + productTitle.textContent.trim() : 'Quantity');
        }

        var quantity = input.closest('.quantity');
        if (!quantity) return;
        quantity.querySelectorAll('.plus, .c_plus, .minus, .c_minus').forEach(function (button) {
          if (!button.matches('button, input, a')) {
            button.setAttribute('role', 'button');
            button.setAttribute('tabindex', '0');
          } else if (button.matches('a')) {
            button.setAttribute('role', 'button');
          }
          if (!button.getAttribute('aria-label')) {
            var action = button.classList.contains('plus') || button.classList.contains('c_plus') ? 'Increase' : 'Decrease';
            button.setAttribute('aria-label', action + ' ' + input.getAttribute('aria-label'));
          }
          if (input.id && !button.getAttribute('aria-controls')) button.setAttribute('aria-controls', input.id);
        });
      });
    },

    decorateAddToCartControls: function (scope) {
      scope.querySelectorAll('.js_addtc').forEach(function (control) {
        if (control.matches('a, button, input')) return;
        control.setAttribute('role', 'button');
        control.setAttribute('tabindex', '0');
        if (!control.getAttribute('aria-label')) {
          control.setAttribute('aria-label', control.textContent.trim() || 'Add item to cart');
        }
      });
    },

    observeDrawer: function () {
      var drawer = this.getDrawer();
      if (!drawer || !window.MutationObserver) return;
      var self = this;
      new MutationObserver(function () {
        self.decorate();
        self.restorePendingQuantityFocus();
      }).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    },

    onClick: function (event) {
      var target = event.target;
      var drawer = this.getDrawer();
      if (!drawer) return;

      var addButton = target.closest(ADD_TO_CART_SELECTOR);
      if (addButton) this.rememberOpener(addButton);

      var cartTrigger = target.closest(CART_TRIGGER_SELECTOR);
      if (cartTrigger && !this.openingFromController) {
        this.rememberOpener(cartTrigger);
        var self = this;
        window.setTimeout(function () { self.activate(); }, 50);
      }

      if (this.isOpen() && target.closest('.js_cart_rem')) {
        this.pendingRemoval = target.closest('.js_cart_item');
      }

      if (this.isOpen() && target.closest('#nt_cart_canvas .mini_cart_close')) {
        event.preventDefault();
        event.stopPropagation();
        this.close();
      }

      if (this.isOpen() && target.matches('.mask-overlay')) {
        event.preventDefault();
        this.close();
      }
    },

    onKeydown: function (event) {
      if (event.target.matches('.js_addtc[role="button"]') && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault();
        event.target.click();
        return;
      }

      if (event.target.matches('.quantity .plus[role="button"], .quantity .minus[role="button"], .quantity .c_plus[role="button"], .quantity .c_minus[role="button"]') && event.key === ' ') {
        event.preventDefault();
        event.target.click();
        return;
      }

      if (!this.isOpen()) return;
      var drawer = this.getDrawer();

      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        this.close();
        return;
      }

      if (event.key !== 'Tab') return;
      var focusable = Array.prototype.filter.call(drawer.querySelectorAll(FOCUSABLE_SELECTOR), this.isVisible.bind(this));
      if (!focusable.length) {
        event.preventDefault();
        drawer.focus();
        return;
      }

      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    },

    onCartChange: function (event) {
      var detail = event.detail || {};
      if (detail.success === false) {
        this.clearPendingQuantityFocus();
        var failedInput = this.findQuantityInput(detail.itemKey, detail.item);
        if (failedInput && detail.previousQuantity !== undefined) failedInput.value = detail.previousQuantity;
        if (this.isVisible(failedInput)) failedInput.focus();
        this.announce('Unable to update cart. Please try again.');
        return;
      }
      if (detail.success !== true) return;
      var self = this;
      window.setTimeout(function () {
        if (detail.quantity === 0) {
          if (self.isOpen()) {
            var nextRemove = self.getDrawer().querySelector('.js_cart_rem');
            var closeButton = self.getDrawer().querySelector('.mini_cart_close');
            (nextRemove || closeButton || self.getDrawer()).focus();
          }
          self.announce('Item removed from cart.');
        } else {
          if (self.isOpen()) {
            self.queueQuantityFocus(detail);
          }
          self.announce('Cart quantity updated to ' + detail.quantity + '.');
        }
      }, detail.quantity === 0 ? 300 : 0);
    },

    onCartAdd: function (event) {
      var detail = event.detail || {};
      if (detail.success !== true) return;
      this.openLastOpener(detail.message || 'Item added to cart. Cart drawer opened.');
    },

    rememberOpener: function (control) {
      if (!control) return;

      if (!control.getAttribute('data-a11y-cart-focus-key')) {
        var key = control.id || control.getAttribute('data-pid') || control.closest('form')?.id;
        if (!key) key = 'opener-' + Date.now() + '-' + Math.random().toString(36).slice(2);
        control.setAttribute('data-a11y-cart-focus-key', key);
      }

      var productScope = control.closest('[data-product-id], .product, .product-item, .product-info, .pr_summary');
      this.lastOpener = {
        element: control,
        focusKey: control.getAttribute('data-a11y-cart-focus-key'),
        formId: control.closest('form')?.id || '',
        productId: control.getAttribute('data-pid') || productScope?.getAttribute('data-product-id') || ''
      };
    },

    findLastOpener: function () {
      var opener = this.lastOpener;
      if (!opener) return null;
      if (this.isVisible(opener.element)) return opener.element;

      var keyedControl = Array.prototype.find.call(
        document.querySelectorAll('[data-a11y-cart-focus-key]'),
        function (element) { return element.getAttribute('data-a11y-cart-focus-key') === opener.focusKey; }
      );
      if (this.isVisible(keyedControl)) return keyedControl;

      if (opener.formId) {
        var form = document.getElementById(opener.formId);
        var formControl = form && form.querySelector(ADD_TO_CART_SELECTOR);
        if (this.isVisible(formControl)) return formControl;
      }

      if (opener.productId) {
        var productControl = Array.prototype.find.call(
          document.querySelectorAll('[data-product-id]'),
          function (element) { return element.getAttribute('data-product-id') === opener.productId; }
        );
        var addControl = productControl && productControl.querySelector(ADD_TO_CART_SELECTOR);
        if (this.isVisible(addControl)) return addControl;
      }

      return null;
    },

    findQuantityInput: function (itemKey, fallbackItem) {
      var drawer = this.getDrawer();
      if (!drawer) return null;

      var input = itemKey && Array.prototype.find.call(
        drawer.querySelectorAll('.qty_cart_js[data-id]'),
        function (element) { return element.getAttribute('data-id') === itemKey; }
      );
      return input || fallbackItem?.querySelector('.qty_cart_js') || null;
    },

    focusUpdatedQuantity: function (detail, attempts) {
      var input = this.findQuantityInput(detail.itemKey, detail.item);
      if (this.isVisible(input)) {
        input.focus();
        return;
      }
      if (attempts <= 0 || !this.isOpen()) return;

      var self = this;
      window.setTimeout(function () {
        self.focusUpdatedQuantity(detail, attempts - 1);
      }, 50);
    },

    queueQuantityFocus: function (detail) {
      this.pendingQuantityFocus = detail;
      if (this.pendingQuantityFocusTimeout) window.clearTimeout(this.pendingQuantityFocusTimeout);
      this.focusUpdatedQuantity(detail, 6);

      var self = this;
      this.pendingQuantityFocusTimeout = window.setTimeout(function () {
        self.clearPendingQuantityFocus();
      }, 1000);
    },

    restorePendingQuantityFocus: function () {
      if (!this.pendingQuantityFocus || !this.isOpen()) return;
      this.focusUpdatedQuantity(this.pendingQuantityFocus, 6);
    },

    clearPendingQuantityFocus: function () {
      this.pendingQuantityFocus = null;
      if (this.pendingQuantityFocusTimeout) {
        window.clearTimeout(this.pendingQuantityFocusTimeout);
        this.pendingQuantityFocusTimeout = null;
      }
    },

    openLastOpener: function (message) {
      var drawer = this.getDrawer();
      if (!drawer) return;

      var self = this;
      window.setTimeout(function () {
        if (!self.isOpen()) {
          var trigger = document.querySelector(CART_TRIGGER_SELECTOR);
          if (trigger) {
            self.openingFromController = true;
            trigger.click();
            self.openingFromController = false;
          }
        }
        self.activateWhenOpen(message || 'Item added to cart. Cart drawer opened.', 8);
      }, 250);
    },

    activateWhenOpen: function (message, attempts) {
      var self = this;
      if (this.isOpen()) {
        this.activate(message);
        return;
      }
      if (attempts <= 0) return;
      window.setTimeout(function () {
        self.activateWhenOpen(message, attempts - 1);
      }, 50);
    },

    activate: function (message) {
      var drawer = this.getDrawer();
      if (!drawer || !this.isOpen()) return;
      drawer.setAttribute('aria-hidden', 'false');
      this.decorate();

      if (!drawer.contains(document.activeElement)) {
        var target = drawer.querySelector('.mini_cart_close') || drawer.querySelector(FOCUSABLE_SELECTOR) || drawer;
        target.focus();
      }
      if (message) this.announce(message);
    },

    close: function () {
      var drawer = this.getDrawer();
      if (!drawer) return;

      this.clearPendingQuantityFocus();
      drawer.classList.remove('act_opened');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('hside_opened');
      document.body.classList.remove('pside_opened');
      document.querySelectorAll(CART_TRIGGER_SELECTOR).forEach(function (trigger) {
        trigger.classList.remove('act_current');
      });
      var mask = document.querySelector('.mask-overlay');
      if (mask) mask.classList.remove('mask_opened');

      var fallback = document.querySelector(CART_TRIGGER_SELECTOR);
      (this.findLastOpener() || fallback || drawer).focus();
    },

    announce: function (message) {
      var status = this.isOpen()
        ? document.getElementById('mini-cart-status')
        : document.getElementById('cart-page-status') || document.getElementById('mini-cart-status');
      if (!status) return;
      status.textContent = '';
      window.requestAnimationFrame(function () { status.textContent = message; });
    }
  };

  window.ThemeA11yCart = controller;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { controller.init(); });
  } else {
    controller.init();
  }
}());
